

















































































import Vue from "vue";

// Model
import { Denomination } from "@/model/data/Denomination";
import { CashTypeEnum } from "@/model/data/enums/CashTypeEnum";
import { CashDetail } from "@/model/data/CashDetail";
import { getSourceDestEnumLabel, SourceDestEnum } from "@/model/data/fitnessStatistics/SourceDestEnum";
import { LocalStorageManager, LocalStorageRequests } from "@/plugins/LocalStorageManager";

enum StatisticsTypeEnum {
    totInFit,
    totInUnfit,
    totOut,
}

export default Vue.extend({
    data() {
        return {
            exportRadio: "csv",
            downloadDialog: false,
            glnReporter: null,
            glnOwner: null,
            xmlRadioSelection: "xml_opr",
            selectedModeCsvConf: "branch",
            csvConfSelectItem: [
                {
                    text: this.$t("statisticsReport.branch"),
                    value: "branch",
                },
                {
                    text: this.$t("statisticsReport.installation"),
                    value: "installation",
                },
            ],
        };
    },
    props: ["loading", "statisticsList", "confExists"],
    computed: {
        exportTypes() {
            let exportTypes = [
                { type: "csv", icon: "file-csv", i18nLabel: "common.exportAsCsv" },
                { type: "pdf", icon: "file-pdf", i18nLabel: "common.exportAsPdf" },
                { type: "xml", icon: "file-code", i18nLabel: "statisticsReport.downloadXml" },
            ];
            if (this.confExists) exportTypes.splice(1, 0, { type: "csvConf", icon: "file-csv", i18nLabel: "common.exportAsCsvConf" });
            return exportTypes;
        },
        headers() {
            let res = [];
            res.push({ text: this.$t("statisticsReport.source"), value: "source", groupable: true });
            res.push({ text: this.$t("common.type"), value: "type", groupable: false });
            this.denominations.forEach((den: Denomination) => {
                res.push({ text: den.toString(), value: den.toString(), groupable: false });
            });
            return res;
        },

        denominations() {
            let denominations = [];
            let values = [500, 200, 100, 50, 20, 10, 5];

            values.forEach((value) => {
                let den: Denomination = new Denomination();
                den.currency = "EUR";
                den.value = value;
                den.type = CashTypeEnum.Banknote;
                denominations.push(den);
            });

            return denominations;
        },

        items() {
            let items = [];
            for (let s of this.statisticsList) {
                Object.keys(StatisticsTypeEnum)
                    .filter((item) => isNaN(Number(item)))
                    .forEach((type) => {
                        let item = {};
                        item["source"] = this.$t(getSourceDestEnumLabel(SourceDestEnum[s.sourceDest] as any));
                        item["type"] = this.$t("statisticsReport." + type);

                        items.push(item);
                        this.denominations.forEach((den) => {
                            item[den.toString()] = s[type].find((c: CashDetail) => c.denomination.isEquals(den))
                                ? s[type].find((c: CashDetail) => c.denomination.isEquals(den)).quantity
                                : 0;
                        });
                    });
            }
            return items;
        },
    },
    watch: {
        glnReporter(newValue) {
            LocalStorageManager.Write(LocalStorageRequests.GlnReporter, newValue);
        },

        glnOwner(newValue) {
            LocalStorageManager.Write(LocalStorageRequests.GlnOwner, newValue);
        },
    },
    methods: {
        reset() {
            this.glnReporter = LocalStorageManager.Read(LocalStorageRequests.GlnReporter);
            this.glnOwner = LocalStorageManager.Read(LocalStorageRequests.GlnOwner);
            this.downloadDialog = false;
        },

        onDownloadClick() {
            if (this.items.length == 0) return;
            if (this.exportRadio != "xml") {
                if (this.exportRadio == "csvConf") this.$emit("download", { exportType: "csv", fromConf: true, glnReporter: null, glnOwner: null, mode: this.selectedModeCsvConf });
                else this.$emit("download", { exportType: this.exportRadio, glnReporter: null, glnOwner: null });
            } else {
                switch (this.xmlRadioSelection) {
                    case "xml_opr":
                        this.$emit("download", { exportType: "xml", glnReporter: this.glnReporter, glnOwner: this.glnOwner });
                        break;
                    case "xml_legacy":
                        this.$emit("download", { exportType: "zip", glnReporter: null, glnOwner: null });
                        break;
                    default:
                        break;
                }
            }
            this.reset();
        },
    },
    mounted() {
        this.reset();
    },
});
